import { useState } from "react";
import { ChatLayout, SidePopupLayout } from "src/component";

export const ChatPop: React.FC<any> =({close}) => {
    
    return (
        <SidePopupLayout overflow='hidden' close={close}>
            <ChatLayout />
        </SidePopupLayout>
    )
}